export const KEYS_CODE = {
  ESC: 27,
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  F5: 116,
};
